var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLight = function SvgCloseLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "E42C804E-67F6-4D3A-857D-A49D148DBA40")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(-1030.000000, -768.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1009.000000, 747.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(19.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-Close-light",
    transform: "translate(2.571910, 2.571910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-185-Copy",
    transform: "translate(9.428090, 9.428090) rotate(-45.000000) translate(-9.428090, -9.428090) translate(2.761424, 2.761424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,2.26898808e-13 C7.12690396,2.26926989e-13 7.5,0.373096042 7.5,0.833333333 L7.499,5.833 L12.5,5.83333333 C12.9602373,5.83333333 13.3333333,6.20642938 13.3333333,6.66666667 C13.3333333,7.12690396 12.9602373,7.5 12.5,7.5 L7.499,7.499 L7.5,12.5 C7.5,12.9602373 7.12690396,13.3333333 6.66666667,13.3333333 C6.20642938,13.3333333 5.83333333,12.9602373 5.83333333,12.5 L5.833,7.499 L0.833333333,7.5 C0.373096042,7.5 5.63628126e-17,7.12690396 0,6.66666667 C-5.63628126e-17,6.20642938 0.373096042,5.83333333 0.833333333,5.83333333 L5.833,5.833 L5.83333333,0.833333333 C5.83333333,0.373096042 6.20642938,2.26870626e-13 6.66666667,2.26898808e-13 Z",
    id: "Combined-Shape"
  })))))))));
};
export default SvgCloseLight;